/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/spp_shopify20250904143543_33175de8227b770dd6297486bdedf7f6_6582a92b-2e61-48bf-8f98-08843aba3943.jpg?v=1757304329&width=1946',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/spp_shopify20250904143543_9664ab5c054a5d35cded1442bddb3a92_99fd0a7a-a39d-4658-b90f-2dc6b4a915a5.jpg?v=1757304329&width=1946',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/spp_shopify20250904143543_9535d64960a660f5e43bafbd38b4aaa6_b5ab621b-d2ca-475b-a384-c8a266c3d0cf.jpg?v=1757304329&width=1946',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/spp_shopify20250904143545_6534c76af3bb6ce9a8cad008653bf5ec_2e97bcf5-0fe7-4918-b1d3-70c6809872c8.jpg?v=1757304329&width=1946',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/9a356c15c0bd49ed8f79cba796a563af_0acc4eb7-c6b1-4d87-acc2-cf4bdf7b64f0.png?v=1757991828&width=1946',
    'https://cdn.shopify.com/s/files/1/0557/8925/6837/files/623_1_e964f944-e0f2-4743-91d7-04c181d54dd8.jpg?v=1757992186&width=1946',

    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A-01.png?v=1757572524',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-B-01.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-C-01.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B-01.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C-01.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C_D-01.png?v=1757572523',

    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A-02.png?v=1757572524',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-B-02.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-C-02.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B-02.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C-02.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C_D-02.png?v=1757572523',

    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A-03.png?v=1757572524',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-B-03.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-C-03.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B-03.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C-03.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C_D-03.png?v=1757572523',

    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A-04.png?v=1757572524',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-B-04.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-C-04.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B-04.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C-04.png?v=1757572523',
    'https://cdn.shopify.com/s/files/1/0617/1534/9592/files/20250911-A_B_C_D-04.png?v=1757572523',
  ]

  new Swiper('.sp-swiper-btn', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
      delay: 4000,
    },
    slidesPerView: 1,

    loop: true,
  })
  new Swiper('.sp-swiper', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
      delay: 1500,
    },
    speed: 1,
    slidesPerView: 1,

    loop: true,
  })
  let spswiper0 = new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    on: {
      slideChange: function (e) {
        $('#swiper-btns .sp-swiper-option')
          .eq(e.realIndex)
          .addClass('active')
          .siblings()
          .removeClass('active')
      },
    },
    loop: true,
  })
  // 点击切换轮播
  $('#swiper-btns .sp-swiper-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    spswiper0.slideToLoop($(this).index())
  })
  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')

      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到绑品位置
    var linksBind = document.querySelectorAll('a[href^="#add-to-cart-form"]')
    linksBind.forEach(function (link) {
      link.addEventListener('click', function (event) {
        console.log(event)
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('add-to-cart-form') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() +
          $('.sp-header-top').height() +
          $('.sp-nav').height() -
          370
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() +
          $('.sp-header-top').height() +
          $('.sp-nav').height() +
          50
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()
  let sp_price1 = 19.99
  let sp_price2 = 39.96

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }

  let prods = window.product
  function getCur() {
    let color = $('#sp-color div.active').attr('data-val')
    let set = $('#sp-set div.active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == set)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)

    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.product-part .price-group .sp-p span').html(off_font)
  }
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

  function showTip() {
    // let result = $("#sp_price1").html();
    // if (result >= 50) {
    //   $(".product-part .sp-btn-tip").show();
    // } else {
    //   $(".product-part .sp-btn-tip").hide();
    // }
  }
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
    showTip()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
    showTip()
  })

  let sptext1 = window.options[0].values
  let sptext2 = window.options[1]?.values || []

  $('.sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $('#sp-color .sp-option.active').index()
    let setOptions = $('#sp-set .sp-option.active').index()

    $('.sp-name1').html(sptext1[colorOptions])
    $('.sp-name2').html(sptext2[setOptions])

    let _index = colorOptions + setOptions * 6
    console.log(_index)
    changePrice()

    $('.product-part .sp-img-p')[0].src = spImgList[colorOptions]

    updateOptions()
  })

  // 更新选项状态
  function updateOptions() {
    const stockMatrix = {
      0: { 0: true, 1: true, 2: true, 3: true, 4: true },
      1: { 0: true, 1: true, 2: true, 3: true, 4: true },
      2: { 0: true, 1: true, 2: true, 3: true, 4: true },
      3: { 0: true, 1: true, 2: true, 3: true, 4: true },
      4: { 0: true, 1: true, 2: true, 3: true, 4: true },
      5: { 0: true, 1: true, 2: true, 3: true, 4: true },
    }
    const selectedColor = $('#sp-color .sp-option.active').index()
    const selectedSet = $('#sp-set .sp-option.active').index()

    // 更新套餐选项状态
    // $('#sp-color .sp-option').each(function (index) {
    //   stockMatrix[index][selectedSet]
    //     ? $(this).removeClass('disabled')
    //     : $(this).addClass('disabled')
    // })
    // $('#sp-set .sp-option').each(function (index) {
    //   stockMatrix[selectedColor][index]
    //     ? $(this).removeClass('disabled')
    //     : $(this).addClass('disabled')
    // })
  }
  $(function () {
    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })

    let initNum = 0
    $('.product-part .cart-btn').click(function () {
      let spNum = $('.product-part #calcNumber')[0].value
      initNum += Number(spNum)

      // $("#calcNumber").val(1);
      // $("#cardNum").html(initNum);
      // handleAddToCart(initNum);
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#cardNum').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })

      var img = $('.product-part .sp-img-p')
      // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");
      // var img = $(".product-part .swiper .swiper-slide-active .sp-img-p");
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        background: '#e7e9ef',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')
    const paragraph2 = gradually.querySelector('.sp-title-color')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            if (paragraph) {
              const totalDelay = spans.length * 0.1 + 0.3
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }
            if (paragraph2) {
              const totalDelay = spans.length * 0.1 + 0.3
              paragraph2.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph2.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
})
